import GameLoader from "../utils/GameLoader";
import BaseView, { ViewOrientation } from "./BaseView";
import PointerEvents from "../../src/const/PointerEvents";
import GameEvents from "../../src/const/GameEvents";
import App from "../App";
import { Tween } from "./../Tween";
import gameModel from "../../src/model/GameModel";
import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import { Graphics, Sprite } from "pixi.js";

/**
 * Displayed while the game is loading.
 * Can be customized per game.
 */
class PreloadView extends BaseView {
    protected bg: Sprite;
    protected loadbar: Sprite;
    protected loadbarPortrait: Sprite;
    protected dot: Sprite;
    protected maskGraphics: Graphics;

    protected _progress: number;


    constructor() {
        super();
        this.init();
    }
    protected init () {
        const scene =  ViewManager.getLayer(DefaultLayers.Preloader).setScene("loader");
        this.loadbar = scene.sceneSprites.get("loadbar");

        if (scene.sceneSprites.has("dot")) {
            this.dot = scene.sceneSprites.get("dot");
        }
        this.maskGraphics = new Graphics();
        this.maskGraphics.beginFill(0xff00ff, 0.01);
        this.maskGraphics.drawRect(0, 0, 10, 10);
        this.maskGraphics.endFill();
        this.maskGraphics.height = this.loadbar.getLocalBounds().height;
        this.maskGraphics.width = 1;
        this.maskGraphics.x =0;
        this.maskGraphics.y = this.loadbar.y;//
        this.loadbar.parent.addChild(this.maskGraphics);
        this.loadbar.mask = this.maskGraphics;
        scene.orientationChangeCallback = () => {
            this.maskGraphics.y = this.loadbar.y;
            this.maskGraphics.height = this.loadbar.height;
            this.setProgress(this._progress);
            this.loadbar.parent.addChild(this.maskGraphics);
        };
    }

    public handleProgress (progress) {
        this._progress = progress;
        // const progress = Math.round(loader.progress) / 100;
        // console.log( "Loading... " + (progress * 100).toFixed(0) + "%");
        this.setProgress(progress);
    }

    // public onPreloadComplete() {
    //     // this.onGameRefreshed();
    //     this.preloadComplete();
    //     // App.dispatcher.once(GameEvents.ACTIVATE_PRELOADER_PLAY, this.onGameRefreshed, this);
    // }
    //
    // public preloadComplete() {
    //     App.assets.onResourcesLoaded();
    //     App.dispatcher.emit(GameEvents.LOADING_SCREEN_COMPLETE);
    // }

    public endLoading() {
        App.dispatcher.emit(GameEvents.END_LOADING);
    }

    // public onGameRefreshed() {
        // Tween.killTweensOf(this.maskGraphics);
        // this.maskGraphics.width = this.loadbar.width;
        // Tween.to(this.dot, .25, {alpha: 0});

        // if (!gameModel.isMobile()) {
        //     let text = this.locale.getString("preloader_play");
        //     let playTF = this.assets.getTF(text, this.layout.relHeight(60, this.loadbar), null, "#6b123f");
        //     playTF.anchor.set(.5, .5);
        //     this.assets.addTFStroke(playTF, {strokeColor: "#000000", strokeSize: .5});
        //     this.layout.horizontalAlignCenter(playTF, 0, this.loadbar);
        //     this.layout.verticalAlignMiddle(playTF, 0, this.loadbar);
        //     this.addChild(playTF);
        //     Tween.from(playTF, .5, {alpha: 0, repeat: 12, yoyo: true});
        //     this.interactive = true;
        //     this.once(C_PointerEvt.DOWN, this.endLoading, this);
        // }
    // }

    protected setProgress(progress: number) {
        Tween.killTweensOf(this.maskGraphics);
        if (this.dot) {
            Tween.killTweensOf(this.dot);
            Tween.to(this.dot, .2, {x: this.loadbar.x + this.loadbar.width * (.25 +  progress) - this.dot.width / 2, overwrite: true});
        }
        Tween.to(this.maskGraphics, .2, {width: this.loadbar.width * (.25 + progress), overwrite: true});
    }

    // protected getTexture(texId: string) {
    //     debugger;
    //     return GameLoader.loader.resources.preloader.textures[texId];
    // }
}
export default PreloadView;
